import { ArcarumPriorities } from "./arcarumCosts";

export const localeStrings = {
  materialType: {
    [ArcarumPriorities.RARE]: {
      zh: "稀有素材",
      en: "Rare Materials"
    },
    [ArcarumPriorities.IMPORTANT]: {
      zh: "重要轉世素材",
      en: "Important Materials"
    },
    [ArcarumPriorities.OTHERARCARUM]: {
      zh: "其它轉世素材",
      en: "Other Arcarum Materials"
    },
    [ArcarumPriorities.OTHER]: {
      zh: "其它素材",
      en: "Other Materials"
    },
    [ArcarumPriorities.BASIC]: {
      zh: "基礎素材",
      en: "Basic Materials"
    }
  }
};
